export function toUTCDate(y, m, d) {
    return new Date(Date.UTC(y, m, d));
}
//# sourceMappingURL=to-utc-date.js.map